import React from 'react';
import { motion } from 'framer-motion';
import { Facebook, Twitter, Linkedin, Instagram, Mail, Phone, MapPin } from 'lucide-react';

export const Footer = () => {
  const footerLinks = {
    Product: ['Features', 'Pricing', 'Integrations', 'Changelog', 'Roadmap'],
    Company: ['About Us', 'Careers', 'Blog', 'Press Kit', 'Partners'],
    Resources: ['Documentation', 'Help Center', 'Community', 'Contact', 'Status'],
    Legal: ['Privacy Policy', 'Terms of Service', 'Cookie Policy', 'GDPR', 'Security'],
  };

  const socialLinks = [
    { icon: Facebook, href: '#', color: '#3dd3ee' },
    { icon: Twitter, href: '#', color: '#000' },
    { icon: Linkedin, href: '#', color: '#283750' },
    { icon: Instagram, href: '#', color: '#fad24b' },
  ];

  return (
    <footer className="relative overflow-hidden" style={{ backgroundColor: '#000' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-12 mb-12">
          {/* Brand Section */}
          <div className="lg:col-span-2">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              <div className="flex items-center space-x-2 mb-4">
                <div
                  className="w-10 h-10 rounded-lg flex items-center justify-center"
                  style={{ backgroundColor: '#fff' }}
                >
                  <span className="text-black font-bold text-xl">E</span>
                </div>
                <span className="text-2xl font-bold text-white">EventMaster</span>
              </div>
              <p className="mb-6" style={{ color: '#bbb5ae' }}>
                The all-in-one platform for managing events, ticketing, attendees, and
                creating memorable experiences.
              </p>
              <div className="space-y-3">
                <div className="flex items-center space-x-2" style={{ color: '#bbb5ae' }}>
                  <Mail size={18} />
                  <span>hello@eventmaster.com</span>
                </div>
                <div className="flex items-center space-x-2" style={{ color: '#bbb5ae' }}>
                  <Phone size={18} />
                  <span>+1 (555) 123-4567</span>
                </div>
                <div className="flex items-center space-x-2" style={{ color: '#bbb5ae' }}>
                  <MapPin size={18} />
                  <span>San Francisco, CA</span>
                </div>
              </div>
            </motion.div>
          </div>

          {/* Links Sections */}
          {Object.entries(footerLinks).map(([category, links], index) => (
            <motion.div
              key={category}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <h3 className="text-white font-bold text-lg mb-4">{category}</h3>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link}>
                    <motion.a
                      href="#"
                      whileHover={{ x: 5 }}
                      transition={{ duration: 0.2 }}
                      className="transition-colors duration-300"
                      style={{ color: '#bbb5ae' }}
                      onMouseEnter={(e) => (e.target.style.color = 'white')}
                      onMouseLeave={(e) => (e.target.style.color = '#bbb5ae')}
                    >
                      {link}
                    </motion.a>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>

        {/* Divider */}
        <div
          className="h-px mb-8"
          style={{ backgroundColor: 'rgba(187, 181, 174, 0.2)' }}
        />

        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            style={{ color: '#bbb5ae' }}
          >
            © 2025 EventMaster. All rights reserved.
          </motion.p>

          {/* Social Links */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
            className="flex space-x-4"
          >
            {socialLinks.map((social, index) => {
              const Icon = social.icon;
              return (
                <motion.a
                  key={index}
                  href={social.href}
                  whileHover={{ scale: 1.2, rotate: 5 }}
                  whileTap={{ scale: 0.9 }}
                  transition={{ duration: 0.2 }}
                  className="w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300"
                  style={{
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor = social.color)
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor =
                      'rgba(255, 255, 255, 0.1)')
                  }
                >
                  <Icon size={18} style={{ color: 'white' }} />
                </motion.a>
              );
            })}
          </motion.div>
        </div>
      </div>
    </footer>
  );
};
